import { errors } from '../components/tess-error/tess-error.component';

export const TESS_CONSTANTS = {
  defaultLogLevel: 'medium',
  AGS: 'TCE',
  appName: 'app-tess',
};

export const errorMessage = errors.FORBIDDEN.line1 + ' ' + errors.FORBIDDEN.line2;
